import {createStore} from 'vuex'
import env from './env'
import Router from './router.js'

const getDefaultState = () => {
    return {
        loaded: false,
        token: null,
        token_expire: null,
        maintenance: false,
        queryHistory: {},
        searchHistory: {},
        user: {
            photo: '',
            access: []
        },
        userCompanies: [],
        columns: [],
        url: env.url,
        api: env.api,
        chartsAmountMonthLoaded: false,
        order_report: {},
        dashboard: {
            contracts: [],
            dataChart: {
                deadline: [],
                quantity: []
            },
            deliveries_count: 0,
            pending_invoices: [],
            pending_invoices_total: 0,
            loaded: false,
            alert: false
        }
    }
}

const state = getDefaultState()


const mutations = {
    setToken(state, token, token_expire) {
        state.token = token
        state.token_expire = token_expire
    },
    setQueryHistory(state, queryHistory) {
        state.queryHistory = queryHistory
    },
    setLoadingChartAmount(state, chartsAmountMonthLoaded) {
        state.chartsAmountMonthLoaded = chartsAmountMonthLoaded
    },
    setSearchHistory(state, searchHistory) {
        state.searchHistory = searchHistory
    },
    setUser(state, status) {
        state.user = status.user
        state.columns = status.columns
        state.userCompanies = status.customerControl

        console.log(state.user)
        // Em um método após o login do usuário
        if (window.clarity && state.user) {
            window.clarity("identify", 'userId-' + state.user.id);
        }

    },
    setColumns(state, columns) {
        state.columns = columns
    },
    setMaintenance(state, user) {
        state.maintenance = user
    },
    setOrderReport(state, report) {
        state.order_report = report
    },
    setDashboardContracts(state, contracts) {
        state.dashboard.contracts = contracts
    },
    setDashboardChartData(state, chartData) {
        state.dashboard.dataChart = chartData
    },
    setDashboardDeliveriesCount(state, count) {
        state.dashboard.deliveries_count = count
    },
    setDashboardPendingInvoices(state, data) {
        state.dashboard.pending_invoices = data.invoices
        state.dashboard.pending_invoices_total = data.total
    },
    setDashboardLoaded(state, loaded) {
        state.dashboard.loaded = loaded
    },
    setDashboardAlert(state, alert) {
        state.dashboard.alert = alert
    },
    reset(state) {
        const defaultState = getDefaultState();
        Object.keys(defaultState).forEach(key => {
            state[key] = defaultState[key];
        });
    },
    setLoaded(state, loaded){
        state.loaded = loaded
    },
    setUserCompany({commit}, userCompany) {
        
        const self = this;
        let api = self.state.api + "user-change-customer/" + self.state.user.id;
  
        this.loading = true
  
        const fd = new FormData();
  
        fd.append("customer_control_id", userCompany.id);
  
        // self.$emit('activateSpinner')
        axios
          .post(api, fd)
          .then((response) => {
            
            window.location = window.location
          })
          .catch((error) => {
            self.loading = false
            
          });

    },
}

const actions = {
    setToken({commit}, token, token_expire) {
        localStorage.setItem('token', token)
        localStorage.setItem('token_expire', token_expire)
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token')
        commit('setToken', token, token_expire)
        this.dispatch('initialize')
        Router.push('/admin');
    },
    setQueryHistory({commit}, queryHistory) {
        commit('setQueryHistory', queryHistory)
    },
    setLoadingChartAmount({commit}, queryHistory) {
        commit('setLoadingChartAmount', queryHistory)
    },
    setSearchHistory({commit}, searchHistory) {
        commit('setSearchHistory', searchHistory)
    },
    setMaintenance({commit}, maintenance) {
        commit('setMaintenance', maintenance)
    },
    setOrderReport({commit}, report) {
        commit('setOrderReport', report)
    },
    setColumns({commit}, columns) {
        commit('setColumns', columns)
    },
    
    logout({commit}) {
        axios
            .post(this.getters.api + 'logout')
            .then(() => {
                localStorage.clear();
                commit('setToken', null)
                Router.push("/login");
                setTimeout(function () {
                    window.location.reload();
                }, 500);
            })
            .catch(error => {
                // this.$message("Erro", "Erro ao realizar logout", "error");
            });
    },
    async initialize({commit}) {
        const self = this

        const token = localStorage.getItem('token')
        const token_expire = localStorage.getItem('token_expire')

        if (!token) {
            return await this.dispatch('reset')
        }

        if (!this.getters.token) {
            commit('setToken', token, token_expire)
        }

       return axios.post(this.getters.api + 'me', {
                token: token
            })
            .then(response => {
                
                commit('setUser', response.data)
                commit('setMaintenance', response.data.user.maintenance);
                setTimeout(() => {
                    if (response.data.type_id != 4 && response.data.user.maintenance == true) {
                        Router.push("/in_maintenance");
                    }
                }, 1000);

                if (response.data.terms_of_use > 0 && response.data.user.terms_of_use == 0) {
                    Router.push("/terms_of_use");
                } else {
                    localStorage.setItem('token_expire', response.data.token_expires_at);
                }

                commit('setLoaded', true)                

            })
            .catch(error => {
                localStorage.clear();
                Router.push('/login');
            });
    },
    async reset({commit}) {
        localStorage.clear()
        commit('reset')
    },
    changeUserCompany({commit}, userCompany) {
        commit('setUserCompany', userCompany)
    },
    async fetchDashboardContracts({commit}) {
        try {
            const api = this.getters.api + "contracts/active-contract-list";
            const response = await axios.get(api);
            
            if (response.data.data.length === 0) {
                commit('setDashboardAlert', true);
                commit('setDashboardContracts', []);
            } else {
                commit('setDashboardContracts', response.data.data.ZOOM || []);
                commit('setDashboardAlert', false);
            }
        } catch (error) {
            console.error('Erro ao buscar contratos:', error);
            commit('setDashboardAlert', true);
        }
    },
    async fetchDashboardChartData({commit}) {
        try {
            const api = this.getters.api + "contracts/chartDeadline";
            const response = await axios.post(api);
            
            if (response.data && response.data.data) {
                const chartData = {
                    deadline: Array.isArray(response.data.data.deadline) ? response.data.data.deadline : [],
                    quantity: Array.isArray(response.data.data.quantity) ? response.data.data.quantity : []
                };
                commit('setDashboardChartData', chartData);
            } else {
                commit('setDashboardChartData', { deadline: [], quantity: [] });
            }
            commit('setDashboardLoaded', true);
        } catch (error) {
            console.error('Erro ao buscar dados do gráfico:', error);
            commit('setDashboardChartData', { deadline: [], quantity: [] });
        }
    },
    async fetchDashboardDeliveriesCount({commit}) {
        try {
            const api = this.getters.api + "deliveries?status=pending";
            const response = await axios.get(api);
            
            if (response.data && response.data.data) {
                commit('setDashboardDeliveriesCount', response.data.data.length || 0);
            }
        } catch (error) {
            console.error('Erro ao buscar entregas pendentes:', error);
            commit('setDashboardDeliveriesCount', 0);
        }
    },
    async fetchDashboardPendingInvoices({commit}) {
        try {
            const api = this.getters.api + "invoices/pending";
            const response = await axios.get(api);
            
            const data = {
                invoices: response.data.ZOOM || [],
                total: response.data.count || 0
            };
            commit('setDashboardPendingInvoices', data);
            
            // Lógica do modal (movida do Header.vue)
            const date = new Date().getDate();
            const lastDateShowedModal = localStorage.getItem('showed_invoice_modal');
            
            if (data.invoices.length && lastDateShowedModal != date) {
                localStorage.setItem('showed_invoice_modal', date);
                // Você pode dispatch um evento aqui se necessário
                // this.dispatch('showPendingInvoicesModal');
            }
        } catch (error) {
            console.error('Erro ao buscar faturas pendentes:', error);
            commit('setDashboardPendingInvoices', { invoices: [], total: 0 });
        }
    },
    async initializeDashboard({dispatch}) {
        await Promise.all([
            dispatch('fetchDashboardContracts'),
            dispatch('fetchDashboardChartData'),
            dispatch('fetchDashboardDeliveriesCount'),
            dispatch('fetchDashboardPendingInvoices')
        ]);
    }
}

const getters = {
    api: state => state.api,
    user: state => state.user,
    token: state => state.token,
    token_expire: state => state.token_expires_at,
    queryHistory: state => state.queryHistory,
    searchHistory: state => state.searchHistory,
    userCompanies: state => state.userCompanies,
    loaded: state => state.loaded,
    dashboardContracts: state => state.dashboard.contracts,
    dashboardChartData: state => state.dashboard.dataChart,
    dashboardDeliveriesCount: state => state.dashboard.deliveries_count,
    dashboardPendingInvoices: state => state.dashboard.pending_invoices,
    dashboardPendingInvoicesTotal: state => state.dashboard.pending_invoices_total,
    dashboardLoaded: state => state.dashboard.loaded,
    dashboardAlert: state => state.dashboard.alert
}

const Store = createStore({
    state,
    getters,
    actions,
    mutations
})

// //Se não for ambiente de dev, derrubar o token toda vez que fechar a aba/navegador ou dar F5 na tela
// if (env.url === 'https://api.bauminas.innovareti.com.br/') {

//     window.addEventListener('beforeunload', localStorage.removeItem('token'))

// }

export default Store
